<template>

<modal
            style="z-index:999999"
            z-index="9999"
            name="assignmentPopu"
            classes="v-modal-sec"
            :min-width="200"
            :min-height="200"
            :scrollable="true"
            :reset="true"
            width="750px"
            height="auto"
          >
          <div class="v-modal profile_details_modal error-modal-space" >
            <div class="popup-header fromDetailsPage">
              <h2 class="popup-title">
                <template >{{ popUpTitle }}</template>
               
                
              </h2>
              <span @click="showPopup=false;$modal.hide('assignmentPopu');">
                <em class="material-icons">close</em>
              </span>
            </div>
          </div>
            
 
  
    <form data-vv-scope="assignmentForm" class="relative v-modal" @submit.prevent @keydown.enter.prevent>
      
      <div
        class="popup_info"
        v-if="usersList.length > 0"
        @click="formErrors = ''"
      >
        <span><eye-icon size="1.5x" class="custom-class"></eye-icon></span>
        <div class="info_list">
          <ul v-if="usersList.length > 0">
            <template v-for="(usr, usrIndx) in usersListReviewrsRolesList">
              <li :key="usrIndx">{{ usr["roleName"] }}</li>
            </template>
          </ul>
        </div>
      </div>
      <div class="form-container">
        <div class="vx-row" >
          <div class="vx-col w-full" v-if="usersList.length > 0 && ['CASE_APPROVED','RFE_CASE_APPROVED' ,'SUPERVISOR_FORMS_REVIEW' ,'SUBMIT_TO_USCIS','RFE_SUBMIT_TO_USCIS'].indexOf(ACTIVITYCODE)<=-1">
            <div class="form_group">
              <label for class="form_label">User<em>*</em></label>             
              <div class="con-select w-full select-large">
                <multiselect
                  name="users"
                  v-model="selectedUser"
                  :close-on-select="true"
                  v-validate="'required'"
                  :multiple="false"
                  :show-labels="false"
                  @input="selectUesr"
                  label="tempName"
                  data-vv-as="User"
                  placeholder="Select User"
                  :options="usersList"
                  :searchable="true"
                  :allow-empty="false"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && !isOpen"
                      >{{ values.length }} selected</span
                    >
                    <span
                      class="multiselect__selectcustom"
                      v-if="values.length && isOpen"
                    ></span>
                  </template>
                </multiselect>
              </div>

              <span
                class="text-danger text-sm"
                v-show="errors.has('assignmentForm.users')"
                >{{ errors.first("assignmentForm.users") }}</span
              >
            </div>
          </div>

          <div class="vx-col w-full">
            <div class="form_group mb-4">
              <label class="form_label">Comments<em v-if="['DELETE_LCA'].indexOf(ACTIVITYCODE)<=-1">*</em></label>
              <!-- <vs-textarea
                data-vv-as="Comments"
                v-validate="'required'"
                v-model="comments"
                name="comments"
                class="w-full mb-5"
              /> -->
              <ckeditor  data-vv-as="Comments"
                v-validate="(['DELETE_LCA'].indexOf(ACTIVITYCODE)<=-1)?'required':''"
                v-model="comments"
                name="comments"
                class="w-full mb-5" :editor="editor" :config="editorConfig"></ckeditor>
                
              <span
                class="text-danger text-sm"
                v-show="errors.has('assignmentForm.comments')"
                >Comments are required</span
              >
            </div>
          </div>
        </div>

        <div class="text-danger text-sm formerrors my-2" v-show="formErrors">
          <vs-alert
            color="warning"
            class="warning-alert reg-warning-alert no-border-radius"
            icon-pack="IntakePortal"
            icon="IP-information-button"
            active="true"
            >{{ formErrors }}</vs-alert
          >
        </div>
      </div>

      <div class="popup-footer relative">
        <span class="loader" v-if="loading"
          ><img src="@/assets/images/main/loader.gif"
        /></span>
        <vs-button
          color="dark"
          @click="showPopup = false"
          class="cancel"
          type="filled"
          >Cancel</vs-button
        >
        

        <vs-button
          v-if="ACTIVITYCODE=='RE_ASSIGN'"
          :disabled="loading"
          color="success"
          @click="submitreAssignAction()"
          class="save"
          type="filled"
          >Assign
        </vs-button>
        <vs-button
          v-else
          :disabled="loading"
          color="success"
          @click="submitForm()"
          class="save"
          type="filled"
          >
          <template v-if="['RFE_CASE_APPROVED','CASE_APPROVED'].indexOf(ACTIVITYCODE)>-1">
            Complete Review
          </template>
          <template v-else-if=" ['SUBMIT_TO_USCIS','RFE_SUBMIT_TO_USCIS'].indexOf(ACTIVITYCODE)>-1 ">Submit</template>
          <template v-else-if="['DELETE_LCA'].indexOf(ACTIVITYCODE)>-1">Delete</template>
          <template v-else-if="ACTIVITYCODE =='SUPERVISOR_FORMS_REVIEW'">Review</template>
          <template v-else>Assign</template>
       
        </vs-button>
      </div>
    </form>
  </modal>
</template>
<script>
import moment from "moment";
import { EyeIcon } from 'vue-feather-icons'
import * as _ from "lodash";
import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  components: {
    EyeIcon
  },
  methods: {

    getLcaExecuitiveList(){
      this.selectedSigner =null
      // {{workFlowDetails}}
    
       
      

           //let companyIdRoles =[50,51];
           let branchIdRoles =[14];
            let postData ={
              "matcher":{ "roleIds": [14], "branchId":"", "assignLcaExcutive":false},              
              "page": 1,	
              "perpage":100000000,
              
            };
           
              
              ///lca/assign-lca-executive, this.callFromLcaDetails

            if(this.checkProperty(this.petitionDetails ,'branchId')){
                postData['matcher']['branchId'] = this.checkProperty(this.petitionDetails ,'branchId');
              }else if(this.callFromLcaDetails && this.checkProperty( this.getUserData ,"branchId")){
                postData['matcher']['branchId'] = this.checkProperty(this.getUserData ,'branchId');
                postData['matcher']['assignLcaExcutive'] =true;
              }
              

            
            this.$store.dispatch("getList",{data:postData ,path:'/petition/assign-user-list'} ).then(response => {
             //alert(JSON.stringify(response.list));
             let lst = []
            
            _.forEach(response.list ,(item)=>{

              item['tempName']= item['name'];
          if (
            _.has(item, "name") &&
            _.has(item, "roleName") &&
            item._id != this.getUserData["userId"]
          ) {
            item.tempName = item.name + " (" + item.roleName + ")";
            lst.push(item);
          }
              
            


            });
            this.usersList = lst;


            })



        
      

    },

    selectUesr(item){
      
    },
    openReAssignToReviewerPopUp(){
  this.selectedUser =null;
  this.comments = '';
  this.loading =false;
   this.comments ="Case "+this.petitionDetails.typeDetails.name+", "+this.petitionDetails.subTypeDetails.name+" is being re-assigned for corrections/changes/updates."


   if([50].indexOf(this.getUserRoleId)>-1){
     this.selectedUser = _.find(this.usersList ,{'roleId':51});
     
   }
    if([51].indexOf(this.getUserRoleId)>-1){
      this.usersList = _.filter(this.usersList ,{'roleId':50});
     this.selectedUser = _.find(this.usersList ,{'roleId':50});
   }


   this.$validator.reset();

},
    submitreAssignAction(){
       
      this.$validator.validateAll("assignmentForm").then((result) => {
   
        if(result){
           
            let postData ={
                "petitionId": "",
                "userId": "",
             //   "userName": "",
                //"roleId": '',
                "typeName": "",
                "subTypeName": "",
                "comment": ""
            };
          postData['petitionId'] = this.checkProperty(this.petitionDetails ,'_id'); 
          postData['userId'] = this.checkProperty(this.selectedUser ,"_id"),
         // postData['userName'] = self.checkProperty(self.selectedAssignToReviewer ,'roleName'); 
       //   postData['roleId'] = self.checkProperty(self.selectedAssignToReviewer ,'roleId'); 
          postData['typeName'] = this.checkProperty(this.petitionDetails,'typeDetails','name'); 
          postData['subTypeName'] = this.checkProperty(this.petitionDetails,'subTypeDetails','name');
          postData['comment'] = this.comments; 
          this.loading =true;
          let url ="/petition/reassign"; 
          if([3].indexOf(this.checkProperty(this.petitionDetails,'typeDetails', 'id' )) >-1 &&  [15].indexOf(this.checkProperty(this.petitionDetails,'subTypeDetails', 'id' )) >-1 ){
            url = "/perm/reassign"; 
          }
    this.$store.dispatch("commonAction" ,{data:postData,path:url})
        .then(response => {
          this.showPopup =false;
                
                this.showToster({message:response.message,isError:false });
                  this.loading =false;
                   this.$emit("updatepetition" ,'');
                   this.$emit("hideMe");                
                

            
        }).catch((err)=>{
           
            this.formErrors =error;
            this.loading =false;
          
        })
        }

      })


    },

    submitForm() {
    this.$validator.validateAll("assignmentForm").then((result) => {
            if (result) {
              let postData = {
               petitionId: this.petitionDetails['_id'],
                comment: this.comments,
                  "userId": this.checkProperty(this.selectedUser ,"_id"),
                  "userName": this.checkProperty(this.selectedUser ,"name"),
                  "roleId":  this.checkProperty(this.selectedUser ,"roleId"),
                  "assignRoleName":  this.checkProperty(this.selectedUser ,"roleName"),
                  subTypeName:this.checkProperty(this.petitionDetails,'subTypeDetails','name'),
                  typeName:this.checkProperty(this.petitionDetails,'typeDetails','name'),
                   "action":this.ACTIVITYCODE, //"ASSIGN_SUPERVISOR", // "ASSIGN_PARALEGAL" / "ASSIGN_DOCUMENTATION_MANAGER" / "ASSIGN_DOCUMENTATION_EXECUTIVE" / "ASSIGN_ATTORNEY"
                 isSkippedAction:false

              };
            let path = "/petition/assign-a-role";
              if(this.ACTIVITYCODE == "SUPERVISOR_FORMS_REVIEW" || ['RFE_CASE_APPROVED','CASE_APPROVED'].indexOf(this.ACTIVITYCODE)>-1 || ['SUBMIT_TO_USCIS','RFE_SUBMIT_TO_USCIS'].indexOf(this.ACTIVITYCODE)>-1){
                path = "/petition/manage-approval-process";
                 postData = {
                petitionId: this.petitionDetails['_id'],
                comment: this.comments,
                subTypeName:this.checkProperty(this.petitionDetails,'subTypeDetails','name'),
                typeName:this.checkProperty(this.petitionDetails,'typeDetails','name'),
                 "action":this.ACTIVITYCODE, //"ASSIGN_SUPERVISOR", // "ASSIGN_PARALEGAL" / "ASSIGN_DOCUMENTATION_MANAGER" / "ASSIGN_DOCUMENTATION_EXECUTIVE" / "ASSIGN_ATTORNEY"
today: moment().format('YYYY-MM-DD')
              }

              }

              if([3].indexOf(this.checkProperty(this.petitionDetails,'typeDetails', 'id' )) >-1 &&  [15].indexOf(this.checkProperty(this.petitionDetails,'subTypeDetails', 'id' )) >-1){
                  path ="/perm/assign-a-role";
                  if(['RFE_CASE_APPROVED','CASE_APPROVED'].indexOf(this.ACTIVITYCODE)>-1 || ['SUBMIT_TO_USCIS','RFE_SUBMIT_TO_USCIS'].indexOf(this.ACTIVITYCODE)>-1){
                    path = "/perm/manage-approval-process";
                  }

               }
              // alert(this.callFromLcaDetails)
              
               if(this.callFromLcaDetails && this.ACTIVITYCODE == "ASSIGN_LCA_EXECUTIVE" ){
                 ///lca/assign-lca-executive, this.callFromLcaDetails
                 //alert(this.callFromLcaDetails)
                 postData = {
                    lcaId: this.petitionDetails['_id'],
                    comment: this.comments,
                    "userId": this.checkProperty(this.selectedUser ,"_id"),
                    "userName": this.checkProperty(this.selectedUser ,"name"),
                    "roleId":  this.checkProperty(this.selectedUser ,"roleId"),
                    "assignRoleName":  this.checkProperty(this.selectedUser ,"roleName"),
                    "action":this.ACTIVITYCODE, //"ASSIGN_SUPERVISOR", // "ASSIGN_PARALEGAL" / "ASSIGN_DOCUMENTATION_MANAGER" / "ASSIGN_DOCUMENTATION_EXECUTIVE" / "ASSIGN_ATTORNEY"
                    today: moment().format('YYYY-MM-DD')

                  }
                path = "/lca/assign-lca-executive";
               }
               if(this.callFromLcaDetails && this.ACTIVITYCODE == "DELETE_LCA" ){
               // "lcaIds": ["62838db9a0b9426170eff1b7", "627e050ef5f9a82b34662c57"],
		            //"comment": "Some Comments",  //Optional
                 postData = {
                    lcaIds: [this.petitionDetails['_id']],
                    comment: this.comments,
                    today: moment().format('YYYY-MM-DD')

                  }
                path = "/lca/delete";
               }
    

              
              //alert(JSON.stringify(postData))
               this.loading =true;
               this.$store
              .dispatch("commonAction", {"data":postData ,"path":path})
              .then(response => {
                this.showPopup =false;
                this.openAtornyPopup =false;
                this.showToster({message:response.message,isError:false });
                  this.loading =false;
                   this.$emit("updatepetition" ,'');
                   this.$emit("hideMe");
                
                
                
                                
              })
              .catch((error)=>{
                if(this.callFromLcaDetails && this.ACTIVITYCODE == "DELETE_LCA" ){
                  let errorList = error;
                  this.formErrors = errorList.join(', ');
                }
                this.formErrors =error;
                this.loading =false;
              })
              
       
       

              
            }
          });
    },
    hideMe() {
      this.$emit("hideMe");
    },
  },
  watch: {
    showPopup(val) {
      if (!val){
        this.$emit("hideMe");
        this.$modal.hide('assignmentPopu');
      }
    },
  },
  mounted() {
    this.showPopup = true;

if(this.ACTIVITYCODE == "RE_ASSIGN"){
 
      let self = this;
      this.caseUsers = [];
      let postData = {
        petitionId: self.petitionDetails['_id'],
        page: 1,
        perpage: 2500,
      };

      let url ="/petition/assigned-user-list"; 
          if([3].indexOf(this.checkProperty(this.petitionDetails,'typeDetails', 'id' )) >-1 &&  [15].indexOf(this.checkProperty(this.petitionDetails,'subTypeDetails', 'id' )) >-1){
            url = "/perm/assigned-user-list"; 
          }
      this.$store
        .dispatch("getList", {
          data: postData,
          path:url,
        })
        .then((response) => {
          if (self.checkProperty(response, "list")) {
            let list = [];
            _.forEach(response["list"], (user) => {
              user['tempName']= user['name'];
              if (_.has(user, "roleName")) {
                 user["tempName"] =
                  user["name"] + " (" + user["roleName"] + ")";
              }
              list.push(user);
            });
            self.usersList = list;
          }
          self.openReAssignToReviewerPopUp();
        }).catch((err)=>{
          self.openReAssignToReviewerPopUp();
        })

}else{


if( ['RFE_CASE_APPROVED','CASE_APPROVED'].indexOf(this.ACTIVITYCODE)<=-1  &&  this.callFromLcaDetails==false){
    this.comments = "Case "+this.petitionDetails.typeDetails.name+", "+this.petitionDetails.subTypeDetails.name+" is being assigned for further actions";
}
if(this.ACTIVITYCODE == "SUPERVISOR_FORMS_REVIEW"){
  this.comments = "Case "+this.petitionDetails.typeDetails.name+", "+this.petitionDetails.subTypeDetails.name+" is being assigned for further actions";

}

  if(this.ACTIVITYCODE == "ASSIGN_LCA_EXECUTIVE"){
    this.getLcaExecuitiveList();
  }
  else if(this.ACTIVITYCODE == "DELETE_LCA"){

  }
  else{
        
    let self = this;
    let postData = {
        petitionId: self.petitionDetails['_id'],
        entityType:'case',
        page: 1,
        perpage: 2500,
      "action":this.ACTIVITYCODE
      };
      
      let url ="/petition/assign-user-list"; 
      if([3].indexOf(this.checkProperty(this.petitionDetails,'typeDetails', 'id' )) >-1 &&  [15].indexOf(this.checkProperty(this.petitionDetails,'subTypeDetails', 'id' )) >-1){
        url = "/perm/assign-user-list";
        postData['entityType'] = 'perm'
      }
      url = "/petition-common/get-users-for-assign";
      
      let assignMentUsersList={
      "ASSIGN_SUPERVISOR":"SUPERVISOR_LIST",
      "ASSIGN_PARALEGAL":"PARALEGAL_LIST",
      "ASSIGN_DOCUMENTATION_MANAGER":"DOCUMENTATION_MANAGER_LIST",
      "ASSIGN_DOCUMENTATION_EXECUTIVE":"DOCUMENTATION_EXECUTIVE_LIST",
      "ASSIGN_ATTORNEY":"ATTORNEY_LIST",
      "REQUEST_PETITIONER_SIGN":"DOC_SIGNER_LIST"

      }
      postData['action'] =this.ACTIVITYCODE;
      if(_.has(assignMentUsersList ,this.ACTIVITYCODE)){
        postData['action'] = assignMentUsersList[this.ACTIVITYCODE];
      }
      
    this.$store
      .dispatch("getList", {
        data: postData,
        /* {
          matcher: { roleIds: this.rolesList, branchId: this.petitionDetails.branchId },
          page: 1,
          perpage: 100000000
        },*/
        path: url,
      })
      .then((response) => {
       
        let lst = [];
        _.forEach(response, (item) => {
          item['tempName']= item['name'];
          if (
            _.has(item, "name") &&
            _.has(item, "roleName") &&
            item._id != this.getUserData["userId"]
          ) {
            item.tempName = item.name + " (" + item.roleName + ")";
            lst.push(item);
          }
        });
        this.usersList = lst;
      });
    }
      if(['SUBMIT_TO_USCIS','RFE_SUBMIT_TO_USCIS'].indexOf(this.ACTIVITYCODE)>-1){
       this.comments ='';
      }
      this.$validator.reset();
 
  }

  this.$modal.show('assignmentPopu');
 
    },
  data: () => ({
    editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },
    usersListReviewrsRolesList:[],
    loading:false,
    comments:null,
    usersList: [],
    showPopup: false,
    settingCaseNumber: false,
        selectedUser:null,
    formErrors: null,
  }),
  props: {
    callFromLcaDetails:{
      type: Boolean,
      default: false,
    },
    ACTIVITYCODE: {
      type: String,
      default: null,
    },
    rolesList: [],
    popUpTitle: {
      type: String,
      default: null,
    },
    petitionDetails: {
      type: Object,
      default: null,
    },
  },
};
</script>
